import React from "react";
import { Route } from "react-router-dom";

import AdminRoute from "../components/Admin/AdminRoute";
import AdminLayout from "../adminPages/AdminLayout";
import AdminBrandPage from "../adminPages/AdminBrandPage";
import AdminAttributePage from "../adminPages/AdminAttributePage";
import AdminBannerPage from "../adminPages/AdminBannerPage";
import AdminProductPage from "../adminPages/AdminProductPage";
import AdminShippingPage from "../adminPages/AdminShippingPage";
import AdminOrderDetailsPage from "../adminPages/AdminOrderDetailsPage";
import AdminOffersPage from "../adminPages/AdminOffersPage";


const AdminRoutes = () => (
  <Route
    path="admin"
    element={
      <AdminRoute>
        <AdminLayout />
      </AdminRoute>
    }
  >
    <Route path="brands" element={<AdminBrandPage />} />
    <Route path="attributes" element={<AdminAttributePage />} />
    <Route path="banners" element={<AdminBannerPage />} />
    <Route path="products" element={<AdminProductPage />} />
    <Route path="orderManagement" element={<AdminShippingPage />} />
    <Route path="orderManagement/:orderId" element={<AdminOrderDetailsPage />} />
    <Route path="offers" element={<AdminOffersPage />} />
  </Route>
);

export default AdminRoutes;
